import { createClone, getNameplateValue } from '../utils/util';
import {
  AnalyticsEvent,
  AnalyticsPageDataType,
  CombinedDigitalDataType,
  defaultDigitalData,
  DigitalDataType,
} from './defaultDigitalData';
import analyticsJson from './page-analytics.json';
import { CookiePreferencesType, onClickValuesToReplace } from './analytics.constants';

export const logAnalytics = (event: string) => {
  console.log(`Analytics Event:- ${event}`);
};

export const getRadUiVersion = (): string => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 768) {
    return 'ui:rad:mobile';
  } else if (screenWidth < 992) {
    return 'ui:rad:tablet';
  }
  // screenWidth >= 992
  return 'ui:rad:pc';
};

export function getAnalyticsScript(): Element {
  let analyticsScript = document.head.querySelector('#digitaldata');
  if (analyticsScript) {
    analyticsScript.remove();
  }
  analyticsScript = document.createElement('script');
  analyticsScript.setAttribute('id', 'digitaldata');
  analyticsScript.setAttribute('type', 'text/javascript');
  document.head.appendChild(analyticsScript);

  return analyticsScript;
}

export function stringifyDigitalData(digitalData: DigitalDataType): string {
  return `var digitaldata = ${JSON.stringify(digitalData)}`;
}

export const getDataForPageEvent = (
  pageName: string,
  eventName: string,
): AnalyticsEvent | undefined => {
  const data = createClone<AnalyticsPageDataType>(analyticsJson);
  const pageDataEvents = data[pageName].events;
  return pageDataEvents.find((event) => event.name === eventName);
};

export const constructDigitalData = (pageEventData: AnalyticsEvent): CombinedDigitalDataType => {
  const digitalData = createClone<DigitalDataType>(defaultDigitalData);
  const digitalDataObject = {
    digitalData,
    directCallName: pageEventData.directCallName,
  };
  pageEventData.digitalDataProperties.forEach((eventProperty) => {
    const [firstProp, secondProp] = eventProperty.propertyDescriptor.split('.');
    digitalDataObject.digitalData[firstProp][secondProp] = eventProperty.value;
  });
  return digitalDataObject;
};

export const fireAnalyticsEvent = (digitalData: DigitalDataType, directCallName: string) => {
  digitalData.page.radUIVersion = getRadUiVersion();
  getAnalyticsScript().innerHTML = stringifyDigitalData(digitalData);
  // eslint-disable-next-line no-underscore-dangle
  if (window._satellite) {
    if (directCallName === 'globalInteraction') {
      window._satellite.track('globalInteraction', {
        onclickLinkName: digitalData.onclick.onclickLinkName,
        onclick: digitalData.onclick.onclick,
        tool: digitalData.page.tool,
        toolDescriptor: digitalData.page.toolDescriptor,
        nameplate: digitalData.vehicle.nameplate,
        leadOptIn: digitalData.user.leadOptIn,
        leadType: digitalData.user.leadType,
      });
      return;
    }
    window._satellite.track(directCallName);
  }
};

export const getCombinedDigitalData = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
): CombinedDigitalDataType => {
  const analyticsValueFromLoadEvent = createClone(analyticsValue);
  const basePageDataForEvent = getDataForPageEvent(pageName, eventName);
  const combinedPageData: AnalyticsEvent = {
    ...basePageDataForEvent,
    digitalDataProperties: [
      ...basePageDataForEvent.digitalDataProperties,
      ...analyticsValueFromLoadEvent.digitalDataProperties,
    ],
  } as AnalyticsEvent;
  return constructDigitalData(combinedPageData);
};

// export const fireAnalyticsForUpfitterFormSuccess = (analyticsValue) => {
//   const { digitalData, directCallName } = getCombinedDigitalData(
//     analyticsValue,
//     ANALYTICS_PAGES.UPFITTER_FORM,
//     FORM_SUBMISSION_SUCCESS_EVENT,
//   );
//   logAnalytics(FORM_SUBMISSION_SUCCESS_EVENT);
//   fireAnalyticsEvent(digitalData, directCallName);
// };

export const replaceTemplateText = (currentString: string, newValue: string) =>
  currentString.replace(onClickValuesToReplace, newValue);

// const isPhone = (link) => link.href?.slice(0, 3) === 'tel';
// const isEmail = (link) => link.href?.slice(0, 3) === 'mai';
//
// const isExternal = (link) => link.href?.startsWith('http');

// const addDownloadButtonListener = (downloadBtnElement, analyticsValue, pageName, eventName) => {
//   downloadBtnElement.addEventListener('click', () => {
//     const downloadLabel = downloadBtnElement.textContent;
//     const { digitalData, directCallName } = getCombinedDigitalData(
//       analyticsValue,
//       pageName,
//       eventName,
//     );
//     if (!downloadLabel.toLowerCase().includes('cancel')) {
//       digitalData.onclick.onclick = replaceTemplateText(
//         digitalData.onclick.onclick,
//         downloadLabel.trim(),
//       );
//       logAnalytics(eventName);
//       fireAnalyticsEvent(digitalData, directCallName);
//     }
//   });
// };

// const addButtonListener = (btnElement, analyticsValue, pageName, eventName, isDownload) => {
//   if (isDownload) {
//     addDownloadButtonListener(btnElement, analyticsValue, pageName, eventName);
//   } else {
//     btnElement.addEventListener('click', () => {
//       const { digitalData, directCallName } = getCombinedDigitalData(
//         analyticsValue,
//         pageName,
//         eventName,
//       );
//       logAnalytics(eventName);
//       fireAnalyticsEvent(digitalData, directCallName);
//     });
//   }
// };

// const addPhoneEmailLinkEventListener = (linkElement, analyticsValue, pageName, eventName) => {
//   const clickType = linkElement.href.slice(0, 3) === 'tel' ? 'click to call' : 'click to email';
//   linkElement.addEventListener('click', () => {
//     const { digitalData, directCallName } = getCombinedDigitalData(
//       analyticsValue,
//       pageName,
//       eventName,
//     );
//     digitalData.onclick.onclick = replaceTemplateText(digitalData.onclick.onclick, clickType);
//     digitalData.user.leadOptIn = clickType;
//     digitalData.page.toolDescriptor = replaceTemplateText(
//       digitalData.page.toolDescriptor,
//       clickType,
//     );
//     logAnalytics(eventName);
//     fireAnalyticsEvent(digitalData, directCallName);
//   });
// };
//
// export const addEventListener = (
//   selector,
//   analyticsValue,
//   pageName,
//   eventName,
//   isDownload = false,
// ) => {
//   const elements = Array.from(document.querySelectorAll(selector));
//   for (let el of elements) {
//     if (!el.href) {
//       addButtonListener(el, analyticsValue, pageName, eventName, isDownload);
//     } else if (isPhone(el) || isEmail(el)) {
//       addPhoneEmailLinkEventListener(el, analyticsValue, pageName, eventName);
//     } else if (isExternal(el)) {
//       addButtonListener(el, analyticsValue, pageName, eventName, isDownload);
//     }
//   }
// };

// export const fireAnalyticsOnButtonCLick = (analyticsValue, pageName, eventName) => {
//   const { digitalData, directCallName } = getCombinedDigitalData(
//     analyticsValue,
//     pageName,
//     eventName,
//   );
//   logAnalytics(eventName);
//   fireAnalyticsEvent(digitalData, directCallName);
// };

export const fireAnalyticsOnAccordionExpand = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  title: string,
  nameplate: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  const parsedTitle = title.replace(/<p>|<\/p>|<sup>|<\/sup>/g, '');
  digitalData.onclick.onclick = replaceTemplateText(digitalData.onclick.onclick, parsedTitle);
  digitalData.vehicle.nameplate = getNameplateValue(nameplate);
  logAnalytics(eventName);
  fireAnalyticsEvent(digitalData, directCallName);
};

export const fireAnalyticsOnShowMoreButtonClicked = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  title: string,
  nameplate: string,
) => {
  fireAnalyticsOnAccordionExpand(analyticsValue, pageName, eventName, title, nameplate);
};

export const fireAnalyticsOnDropDownSelection = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  nameplate: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  digitalData.onclick.onclick = replaceTemplateText(digitalData.onclick.onclick, nameplate);
  digitalData.vehicle.nameplate = getNameplateValue(nameplate);
  fireAnalyticsEvent(digitalData, directCallName);
};

export const fireAnalyticsOnPaginationSelection = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  nameplate: string,
  accordionName: string,
  itemsPerPage: string,
  pageNumber: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  digitalData.onclick.onclick = digitalData.onclick.onclick
    .replace(/<accordion name>/, accordionName)
    .replace(/<items per page #>/, itemsPerPage)
    .replace(/<page #>/, pageNumber);
  digitalData.vehicle.nameplate = getNameplateValue(nameplate);
  fireAnalyticsEvent(digitalData, directCallName);
};

export const fireAnalyticsOnSearchBtnSelection = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  nameplate: string,
) => {
  fireAnalyticsOnDropDownSelection(analyticsValue, pageName, eventName, nameplate);
};

export const fireAnalyticsOnDownloadLinkClicked = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  nameplate: string,
  downloadName: string,
  shortDownloadName?: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  digitalData.onclick.onclick = replaceTemplateText(
    digitalData.onclick.onclick,
    shortDownloadName ?? downloadName,
  );
  digitalData.vehicle.nameplate = nameplate;
  digitalData.page.toolDescriptor = replaceTemplateText(
    digitalData.page.toolDescriptor,
    downloadName,
  );
  fireAnalyticsEvent(digitalData, directCallName);
};

export const fireAnalyticsOnButtonClicked = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  logAnalytics(eventName);
  fireAnalyticsEvent(digitalData, directCallName);
};

export const fireAnalyticsOnLinkClicked = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  fireAnalyticsEvent(digitalData, directCallName);
};

export const getCookiePreferences = (cookiePreferences: CookiePreferencesType) => {
  const settingsArr = [];
  const cookieArr = Object.entries(cookiePreferences);
  for (const cookie of cookieArr) {
    settingsArr.push(cookie.join(':'));
  }
  return settingsArr
    .join('|')
    .replaceAll('_', ' ')
    .replaceAll('true', 'yes')
    .replaceAll('false', 'no');
};

// export const addAccordionLinkAnalytics = (selector, analyticsValue, pageName) => {
//   const links = Array.from(document.querySelectorAll(selector));
//   for (let link of links) {
//     const href = link.href;
//     const linkText = link.textContent;
//     link.addEventListener('click', () => {
//       if (!href.endsWith('.pdf')) {
//         const { digitalData, directCallName } = getCombinedDigitalData(
//           analyticsValue,
//           pageName,
//           EXIT_VIA_FAQ_EVENT,
//         );
//         digitalData.onclick.onclick = replaceTemplateText(digitalData.onclick.onclick, href);
//         digitalData.onclick.referredTo = replaceTemplateText(digitalData.onclick.referredTo, href);
//         logAnalytics(EXIT_VIA_FAQ_EVENT);
//         fireAnalyticsEvent(digitalData, directCallName);
//       } else {
//         const { digitalData, directCallName } = getCombinedDigitalData(
//           analyticsValue,
//           pageName,
//           UIS_DOWNLOAD_EVENT,
//         );
//         digitalData.onclick.onclick = replaceTemplateText(
//           digitalData.onclick.onclick,
//           linkText.trim(),
//         );
//         logAnalytics(UIS_DOWNLOAD_EVENT);
//         fireAnalyticsEvent(digitalData, directCallName);
//       }
//     });
//   }
// };

const isPhone = (link: HTMLElement) => link.href?.slice(0, 3) === 'tel';
const isEmail = (link: HTMLElement) => link.href?.slice(0, 3) === 'mai';
const isExternal = (link: HTMLElement) => link.href?.startsWith('http');

const addDownloadButtonListener = (
  downloadBtnElement: HTMLElement,
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
) => {
  downloadBtnElement.addEventListener('click', () => {
    const downloadLabel = downloadBtnElement.textContent;
    const { digitalData, directCallName } = getCombinedDigitalData(
      analyticsValue,
      pageName,
      eventName,
    );
    if (!downloadLabel.toLowerCase().includes('cancel')) {
      digitalData.onclick.onclick = replaceTemplateText(
        digitalData.onclick.onclick,
        downloadLabel.trim(),
      );
      logAnalytics(eventName);
      fireAnalyticsEvent(digitalData, directCallName);
    }
  });
};

const addButtonListener = (
  btnElement: HTMLElement,
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  isDownload: boolean,
) => {
  if (isDownload) {
    addDownloadButtonListener(btnElement, analyticsValue, pageName, eventName);
  } else {
    btnElement.addEventListener('click', () => {
      // const { digitalData, directCallName } = getCombinedDigitalData(
      //   analyticsValue,
      //   pageName,
      //   eventName,
      // );
      // logAnalytics(eventName);
      // fireAnalyticsEvent(digitalData, directCallName);
      fireAnalyticsOnButtonClicked(analyticsValue, pageName, eventName);
    });
  }
};

const addPhoneEmailLinkEventListener = (
  linkElement: HTMLElement,
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
) => {
  linkElement.addEventListener('click', () =>
    fireAnalyticsOnLinkClicked(analyticsValue, pageName, eventName),
  );
};

export const addEventListener = (
  selector: string,
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  isDownload = false,
) => {
  const elements = Array.from(document.querySelectorAll(selector));
  for (const el of elements) {
    if (!el.href) {
      addButtonListener(el, analyticsValue, pageName, eventName, isDownload);
    } else if (isPhone(el) || isEmail(el)) {
      addPhoneEmailLinkEventListener(el, analyticsValue, pageName, eventName);
    } else if (isExternal(el)) {
      addButtonListener(el, analyticsValue, pageName, eventName, isDownload);
    }
  }
};

// **************** DIGI BEMM related functions *****************
// Same function is being called for Email click as well
export const fireAnalyticsOnPageLoad = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  fileId: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  digitalData.page.pageName = replaceTemplateText(digitalData.page.pageName, fileId);
  digitalData.page.hierarchy = replaceTemplateText(digitalData.page.hierarchy, fileId);
  digitalData.page.pageNameNoVehicle = replaceTemplateText(
    digitalData.page.pageNameNoVehicle,
    fileId,
  );
  fireAnalyticsEvent(digitalData, directCallName);
};

export const fireAnalyticsOnSearchClick = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  searchText: string,
  fileId: string,
) => {
  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  digitalData.page.pageName = replaceTemplateText(digitalData.page.pageName, fileId);
  digitalData.page.toolDescriptor = replaceTemplateText(
    digitalData.page.toolDescriptor,
    searchText,
  );
  digitalData.page.pageNameNoVehicle = replaceTemplateText(
    digitalData.page.pageNameNoVehicle,
    fileId,
  );
  digitalData.page.hierarchy = replaceTemplateText(digitalData.page.hierarchy, fileId);
  fireAnalyticsEvent(digitalData, directCallName);
};

// export const fireAnalyticsOnEmailClick = (
//   analyticsValue: AnalyticsEvent,
//   pageName: string,
//   eventName: string,
// ) => {
//   const { digitalData, directCallName } = getCombinedDigitalData(
//     analyticsValue,
//     pageName,
//     eventName,
//   );
//   digitalData.page.pageName = replaceTemplateText(digitalData.page.pageName, fileId);
//   digitalData.page.pageNameNoVehicle = replaceTemplateText(
//     digitalData.page.pageNameNoVehicle,
//     fileId,
//   );
//   digitalData.page.hierarchy = replaceTemplateText(digitalData.page.hierarchy, fileId);
//   fireAnalyticsEvent(digitalData, directCallName);
// };

export const fireAnalyticsOnUrlClick = (
  analyticsValue: AnalyticsEvent,
  pageName: string,
  eventName: string,
  urlString: string,
  fileId: string,
) => {
  const url = new URL(urlString);
  const fullHostname = url.hostname;
  let baseDomain = fullHostname;
  if (baseDomain.startsWith('www.')) {
    // If it starts with "www.", remove the first 4 characters ("www.")
    baseDomain = baseDomain.substring(4);
  }
  const lastDotIndex = baseDomain.lastIndexOf('.');
  let rootDomain = baseDomain; // Default in case there's no dot (like "localhost")

  if (lastDotIndex !== -1) {
    rootDomain = baseDomain.substring(0, lastDotIndex);
  }

  const { digitalData, directCallName } = getCombinedDigitalData(
    analyticsValue,
    pageName,
    eventName,
  );
  digitalData.page.pageName = replaceTemplateText(digitalData.page.pageName, fileId);
  digitalData.page.pageNameNoVehicle = replaceTemplateText(
    digitalData.page.pageNameNoVehicle,
    fileId,
  );
  digitalData.page.hierarchy = replaceTemplateText(digitalData.page.hierarchy, fileId);

  digitalData.onclick.referredTo = replaceTemplateText(digitalData.onclick.referredTo, baseDomain);
  digitalData.onclick.onclick = replaceTemplateText(digitalData.onclick.onclick, baseDomain);
  digitalData.onclick.onclickLinkName = replaceTemplateText(
    digitalData.onclick.onclickLinkName,
    rootDomain,
  );
  digitalData.page.toolDescriptor = replaceTemplateText(
    digitalData.page.toolDescriptor,
    fullHostname,
  );
  fireAnalyticsEvent(digitalData, directCallName);
};
